import { SortDirectionEnum, useCustomQuery } from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useExportHook, useExportProps, useExportResult } from './types';
import { getDateFilter } from './dateFilterUtils';

export const useTagScanExport: useExportHook = (
  props: useExportProps
): useExportResult => {
  const [rows, setRows] = useState([]);

  const headers = [
    { label: 'Date', key: 'date' },
    { label: 'Time', key: 'time' },
    { label: 'Tag', key: 'tagCode' },
    { label: 'First Name', key: 'firstName' },
    { label: 'Last Name', key: 'lastName' },
    { label: 'Email', key: 'email' },
    { label: 'Phone', key: 'phone' },
    { label: 'Asset', key: 'asset' },
    { label: 'Coordinates', key: 'coordinates' },
    { label: 'Address', key: 'address' },
  ];

  const { data, isLoading } = useCustomQuery({
    query: EXPORT_TAG_SCANS,
    cacheKey: ['exportTagScans', props.workspace.id, props.dateFilter],
    variables: {
      filter: {
        workspaceId: props.workspace.id,
        ...getDateFilter(props.dateFilter),
      },
      orderBy: { field: 'createdAt', order: SortDirectionEnum.Asc },
    },
    options: {
      enabled: props.download,
      gcTime: 10000,
      staleTime: 10000,
    },
  });

  useEffect(() => {
    if (!data) return;

    const exportRows = data.tagScan.exportTagScans.data.map((item: any) => {
      const row = { ...item };
      
      // Split date into date and time
      if (item.date) {
        const date = new Date(item.date);
        row.date = date.toISOString().split('T')[0]; // YYYY-MM-DD
        row.time = date.toISOString().split('T')[1].substring(0, 8); // HH:MM:SS
      }
      
      return row;
    });

    setRows(exportRows);
    props.onDataReady();
  }, [data]);

  return {
    headers,
    rows,
    isLoading,
  };
};

const EXPORT_TAG_SCANS = `
  query TagScanQuery($filter: ExportTagScansFilter) {
    tagScan {
      exportTagScans(filter: $filter) {
        data {
          date
          tagCode
          firstName
          lastName
          email
          phone
          asset
          coordinates
          address
        }
      }
    }
  } 
`;
